/** localStorage key prefix for the per-list email-import "already sent" flag. */
export const STORAGE_KEY_PREFIX = "carriapp:email-import-sent:";

/** Builds the per-list storage key, mirroring onboarding-target-prompt.ts. */
export const getEmailImportStorageKey = (listUuid: string): string =>
    `${STORAGE_KEY_PREFIX}${listUuid}`;

/** Marks the list as having shown the email-import popup. Survives reloads. */
export const markEmailImportOpened = (listUuid: string): void => {
    if (typeof window === "undefined") return;

    try {
        window.localStorage.setItem(getEmailImportStorageKey(listUuid), "true");
    } catch {
        // Non-critical UI flag — if storage is unavailable, the card keeps its original copy.
    }
};

/** Returns true when the user already opened (and closed) the popup for this list. */
export const hasEmailImportOpened = (listUuid: string): boolean => {
    if (typeof window === "undefined") return false;

    try {
        return window.localStorage.getItem(getEmailImportStorageKey(listUuid)) === "true";
    } catch {
        return false;
    }
};

/** Removes the flag once the list has products. */
export const clearEmailImportOpened = (listUuid: string): void => {
    if (typeof window === "undefined") return;

    try {
        window.localStorage.removeItem(getEmailImportStorageKey(listUuid));
    } catch {
        // Ignore — a stale flag is harmless and will be cleared on a later visit.
    }
};